import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSyncAlt, faArrowLeft } from '@fortawesome/pro-solid-svg-icons'

import MainLayout from '../../containers/MainLayout'
import ReportTable from '../../components/ReportTable'
import ErrorPage from '../ErrorPage'
import ButtonLink from '../../components/ButtonLink'

import { useList } from '../../frankentangel'

const OrphanedAccounts = props => {
  const [Paginator, results, error] = useList('accounts', 'listOrphaned')

  if (error) {
    return <ErrorPage error={error} />
  }

  const searchResults = results
    ? results.map(account => account.doc).map(account => {
        return [
          account.callsign,
          account.name,
          account.users.length || 'MISSING',
          account.contract?.name || 'MISSING'
        ]
      })
    : null

  return (
    <MainLayout fullheight alignstart>
      <div className='container'>
        <div className='columns'>
          <div className='column is-full'>
            <div className='columns'>
              <div className='column is-12'>
                <h1 className='title'>Unlinked Accounts</h1>
                <ButtonLink target='/' icon={faArrowLeft} linkText='Back' />
              </div>
            </div>
          </div>
        </div>
        <div className='columns'>
          <div className='column is-full'>
            <Paginator spinner={<div className='has-text-centered my-4'><FontAwesomeIcon icon={faSyncAlt} spin size='3x' /></div>}>
              <ReportTable
                headings={['Call Letters', 'Name', 'Users', 'Contract']}
                tableData={searchResults}
              />
            </Paginator>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

export default OrphanedAccounts
